


import { Component, Vue } from 'vue-property-decorator';

import SignaturePad from '@/shared/components/signature-pad.component.vue';
import Btn from '@/shared/components/btn.component.vue';


@Component({
    components: {
        SignaturePad,
        Btn,
    },
})

export default class PartialSignaturePadComponent extends Vue {
  private componentRef!: any;


  private mounted() {
    this.componentRef = ( this.$refs.signaturePad as SignaturePad);
  }

  private clearSignature() {
    this.componentRef.clearPad();
  }

  private getSignature() {
    // tslint:disable-next-line:no-console
    console.log(this.componentRef.getSignature());
  }
}
